var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: {
        name: "subscription-video-modal",
        width: "100%",
        height: "100%",
        clickToClose: false,
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-wrapper" },
        [
          _c(
            "video",
            { staticClass: "video-box", attrs: { controls: "", autoplay: "" } },
            [
              _c("source", {
                attrs: {
                  src: "/static/videos/readtheory_why_premium.mp4",
                  type: "video/mp4",
                },
              }),
              _vm._v(
                "\n        Your browser does not support the video tag.\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "primary-button",
            { staticClass: "btn-choose", on: { click: _vm.showPlanSection } },
            [_vm._v("Choose your plan")]
          ),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "btn-close", on: { click: _vm.closeModal } },
            [
              _c("rt-picture", {
                attrs: { src: "/assets/app/class/icon-close-white.svg" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }